import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import RegisteredPage from './pages/Registered/RegisteredPage';
import CguPage from './pages/Cgu/CguPage';
import LandingPage from './pages/Landing/LandingPage';
import DataConfidentialityPage from './pages/DataConfidentiality/DataConfidentialityPage';
import FaqPage from './pages/FAQ/FaqPage';
import usePageTracking from './hooks/usePageTracking';

function AppRoutes() {
  usePageTracking(); // <-- tracking des pages

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/registered" element={<RegisteredPage />} />
      <Route path="/cgu" element={<CguPage />} />
      <Route path="/data-confidentiality" element={<DataConfidentialityPage />} />
      <Route path="/faq" element={<FaqPage />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);

  return (
    <div id='app'>
      <Router>
        <AppRoutes />
      </Router>
    </div>
  );
}

export default App;
